var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSea3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 4C12.0004 5.10457 11.1049 6 10.0004 6C8.8958 6 8.0004 5.10457 8.0004 4C8.0004 2.89543 8.8958 2 10.0004 2C11.1049 2 12.0004 2.89543 12.0004 4ZM13.4652 6C13.8056 5.41165 14.0004 4.72857 14.0004 4C14.0004 1.79086 12.2095 0 10.0004 0C7.79122 0 6.00036 1.79086 6.00036 4C6.00036 4.72857 6.19515 5.41165 6.53549 6H3.06615C2.57888 6 2.16255 6.3512 2.08045 6.8315L0.200102 17.8315C0.0957024 18.4423 0.566182 19 1.18581 19H18.8149C19.4345 19 19.905 18.4423 19.8006 17.8315L17.9203 6.8315C17.8382 6.3512 17.4218 6 16.9346 6H13.4652ZM10.0004 8H16.091L17.6295 17H2.37125L3.90971 8H10.0004Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea3);
export default __webpack_public_path__ + "static/media/sea-3.3c48071df1ceb52431d97198e17d4988.svg";
export { ForwardRef as ReactComponent };